export default __webpack_public_path__ + "static/media/Edit.a12970e5.svg";